/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import EndpointsConst from "../consts/EndpointsConst";
import { getAPIUrl } from "../utilities/APIHelper";

class MailService {
  /**
   * [POST]
   * Submits customer contact form
   * @param {String} name
   * @param {String} email
   * @param {String} phoneNumber
   * @param {String} message
   *
   * @returns {Promise}
   */
  submitContactForm({ name, email, phoneNumber, message }) {
    const url = getAPIUrl() + EndpointsConst.API.MAIL.SUBMIT_CONTACT_FORM;
    return axios.post(url, { name, email, phoneNumber, message });
  }
}

export default new MailService();
